import {
    FASTSHIFT_RELATED_TICKET_ISSUE_TYPE,
    FastshiftRelatedTicketIssueType
} from "@/libraries/bxp-web-stargate-client/src/hook/use-bxp-web-stargate-client.types";

import { ConsultIcon } from "../assets/consult-icon";
import { IssueIcon } from "../assets/issue-icon";
import { PlanIcon } from "../assets/plan-icon";
import { ProblemIcon } from "../assets/problem-icon";
import { SupportRequestIcon } from "../assets/support-request-icon";

/**
 * Returns the appropriate icon component for a given migration ticket issue type.
 * Maps the provided issue type to a corresponding icon and color for display.
 * For unknown or unsupported issue types, returns null.
 *
 * @param issueType - The issue type of the related migration ticket
 * @returns The corresponding icon component, or null if not found
 */

export const getMigrationTicketIcon = (
    issueType: FastshiftRelatedTicketIssueType
) => {
    switch (issueType) {
        case FASTSHIFT_RELATED_TICKET_ISSUE_TYPE.CONSULT:
            return <ConsultIcon />;
        case FASTSHIFT_RELATED_TICKET_ISSUE_TYPE.PLAN:
            return <PlanIcon />;
        case FASTSHIFT_RELATED_TICKET_ISSUE_TYPE.SUPPORT_REQUEST:
            return <SupportRequestIcon />;
        case FASTSHIFT_RELATED_TICKET_ISSUE_TYPE.PROBLEM_REPORT:
            return <ProblemIcon />;
        default:
            return <IssueIcon />;
    }
};
